// A rep's primary company (companyName) comes first, followed by any other
// companies they represent. Names are de-duplicated case-insensitively.
export function repCompanyNames(profile) {
  const names = [profile?.companyName, ...(profile?.companies || []).map((company) => company?.name)];
  const seen = new Set();
  return names
    .map((name) => (name || "").toString().trim())
    .filter((name) => {
      const key = name.toLowerCase();
      if (!name || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}
